// Maps a uc_* table name to a logical cluster + colour, mirroring the groupings
// documented in docs/dbmap/PLAN.md. Used for node colouring and the legend.

export interface Cluster {
    id: string;
    label: string;
    color: string;
}

export const CLUSTERS: Cluster[] = [
    { id: 'boards', label: 'Boards', color: '#1f77b4' },
    { id: 'edges', label: 'Edges', color: '#2ca02c' },
    { id: 'decor', label: 'Decor / material', color: '#9467bd' },
    { id: 'style', label: 'Style params', color: '#ff7f0e' },
    { id: 'config', label: 'Product / order config', color: '#d62728' },
    { id: 'other', label: 'Other uc_*', color: '#7f7f7f' },
    { id: 'external', label: 'External (ps_*)', color: '#aaaaaa' },
];

const COLOR_BY_ID: Record<string, string> = Object.fromEntries(
    CLUSTERS.map((c) => [c.id, c.color]),
);

export function clusterOf(tableName: string, external: boolean): string {
    if (external) return 'external';
    const n = tableName;
    if (/^uc_(board|board_structures|boardprices)/.test(n) || n.startsWith('uc_board')) return 'boards';
    if (n.startsWith('uc_edge')) return 'edges';
    if (
        n.startsWith('uc_decor') ||
        n.startsWith('uc_material') ||
        n === 'uc_materials'
    ) return 'decor';
    if (n.startsWith('uc_style') || n.startsWith('uc_drop')) return 'style';
    if (
        n === 'uc_product_configurations' ||
        n === 'uc_configuration_scripts' ||
        n === 'uc_cart' ||
        n === 'uc_proforma_invoices' ||
        n === 'uc_statuses'
    ) return 'config';
    return 'other';
}

export function colorOf(clusterId: string): string {
    return COLOR_BY_ID[clusterId] ?? COLOR_BY_ID.other;
}
